export default "__VITE_PUBLIC_ASSET__a61972b6__"